import { KText } from '@/ui-library/components/text';
import { Flex, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { KTag } from 'ui-library/components';

export const BluePrintTitle = ({
  blueprint = {},
  onCreateFromBlueprint = () => {},
}) => {
  const history = useHistory();
  return (
    <Flex
      height="60px"
      borderBottom="1px solid #E5E5E5"
      px="20px"
      alignItems="center"
    >
      <Flex flex={1} gap="6px">
        <KText size={'md-semi-bold'} color="secondary-900">
          {blueprint?.name}
        </KText>
        <KTag value={`${blueprint?.steps} steps`}></KTag>
      </Flex>
      <Button
        id="use-blueprint"
        variant="secondary"
        mr="12px"
        onClick={() => {
          onCreateFromBlueprint(blueprint);
        }}
      >
        Use this
      </Button>
      <Button
        variant="tertiary"
        onClick={() => {
          history.push(`/blueprints/${blueprint?.id}`);
        }}
      >
        Edit
      </Button>
    </Flex>
  );
};
